/*
 *
 * Estos componentes estan presentes solo en el website
 *
 */

const page="./page/";
// import slick from 'vue-slick';
import BootstrapVue from 'bootstrap-vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
// import VueSocialSharing from 'vue-social-sharing';
import * as VueGoogleMaps from 'vue2-google-maps';

function plugin (Vue) {
	//Componentes llamados
  // Vue.component('slick',slick);
  // Vue.use(VueSocialSharing);
  Vue.component('my-header', require(page+'shared/header.vue').default);
  Vue.component('my-footer', require(page+'shared/footer.vue').default);
  Vue.component('cart-express-component', require(page+'carrito/cart-express-component.vue').default);
	Vue.component('cart-express-modal', require(page+'carrito/cart-express-modal.vue').default);
  Vue.use(BootstrapVue);
  Vue.use(VueAwesomeSwiper, /* { default options with global component } */);
  Vue.use(VueGoogleMaps, {
		load: {
			key: 'AIzaSyDMg821Hyzq37AAG3AG92To_bFIjgTMHRg'
		}
	});
}

// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin
